import { getRawModuleDataFromResponse } from '../../../utils/modules';
import { getShopWidgetConfigs } from '../../components/Sections/ShopSection/shopWidgetConfigs';
import { setTotalPages, setCurrentPage } from '../../actions/pageInfo';
import {
  getCommonSectionInitActions,
  getCustomInitActionsForWidgets,
  getRawSectionModules,
  getModuleData,
} from './common';

export function getShopSectionInitActions(responseData, requestParams) {
  const initActions = getCommonSectionInitActions(
    responseData,
    requestParams,
    'shop'
  ).filter(action => action);
  return [
    ...initActions,
    ...getShopPageInfoInitActions(responseData, requestParams),
  ];
}

export function getShopPageInfoInitActions(responseData, requestParams) {
  return [
    ...getShopCurrentPageInitActions(responseData, requestParams),
    ...getShopTotalPageInitActions(responseData, requestParams),
  ];
}

/** set the shop's currentPage from the request params */
function getShopCurrentPageInitActions(responseData, requestParams) {
  const currentPage = requestParams.page ? parseInt(requestParams.page, 10) : 1;
  return [setCurrentPage(currentPage)];
}

/** set the totalPages of the current stream of shop products (if any) */
function getShopTotalPageInitActions(responseData, requestParams) {
  // note that if we try this in the individual shop product module
  // inits in modules.ts, they will overwrite each other since the
  // `totalPages` are shared between them
  const { shop_section } = requestParams;
  if (!shop_section) {
    return [];
  }

  const modules = getRawSectionModules(responseData);
  const shopSectionModule = getModuleData(modules, shop_section);
  if (!shopSectionModule) {
    return [];
  }

  const moduleData = shopSectionModule.dataKey
    ? getRawModuleDataFromResponse(shopSectionModule)
    : shopSectionModule;
  const { totalPageCount } = moduleData;
  return totalPageCount === 0 || totalPageCount
    ? [setTotalPages(totalPageCount)]
    : [];
}

// new grusers
export const getCustomInitActionsForShopWidgets = (
  responseData,
  requestParams
) => [
  ...getCustomInitActionsForWidgets(
    responseData,
    requestParams,
    getShopWidgetConfigs({ t: () => null, dispatch: () => null })
  ),
  ...getShopPageInfoInitActions(responseData, requestParams),
];
